import takeRequest from '~/store/takeRequest';
import { listTagTypes, listTagTypesPerson } from '~/store/tagTypes/actions';

export function* tagTypesSaga() {
  yield takeRequest(listTagTypes);
  yield takeRequest(listTagTypesPerson);
}
